import { qrCodeWhite } from '#/components/basic/icons/svg';
import { WalletType } from '#/reduxState/wallet/walletUtils';

import coinbaseWalletIcon from './coinbase.svg';
import ethereumIcon from './ethereum.png';
import keystoreIcon from './keystoreA.svg';
import privateKeyIcon from './privateKeyD.svg';
import walletConnectIcon from './walletConnect.svg';
// import bitkeepIcon from './web3/bitkeep.svg';
import metamaskIcon from './web3/metamask.svg';
// import tokenPocketIcon from './web3/tokenPocket.png';
import trustWalletIcon from './web3/trustwallet.svg';
import web3Icon from './web3/web3js.png';
// import ledgerPhoto from './ledger.png';
// import trezorIcon from './trezor.png';

export const getWalletIcon = (
  walletType: WalletType,
  /** For discovered wallet, we will have icons available */
  customIconOverride: string | undefined
): string => {
  if (customIconOverride) {
    return customIconOverride;
  }
  switch (walletType) {
    case 'privateKey':
      return privateKeyIcon;
    case 'keystore':
      return keystoreIcon;
    case 'softwareWeb3':
      return web3Icon;
    case 'softwareDiscovered_metaMask':
      return metamaskIcon;
    case 'softwareDiscovered_trustWallet':
      return trustWalletIcon;
    case 'coinbaseWallet':
      return coinbaseWalletIcon;
    case 'walletConnect':
      return walletConnectIcon;
    case 'qrSynced':
      return qrCodeWhite;
    // case 'ledger':
    //   return ledgerPhoto;
    // case 'trezor':
    //   return trezorIcon;
  }
  return ethereumIcon;
};
